<template>
  <nav id="sidebar" :class="toggleSidebar ? 'active' : ''">
    <div class="scrolleable">
      <!-- Sidebar Header -->
      <!--<div class="sidebar-header">
          <h3>Dash Board</h3>
          <strong>DB</strong>
      </div>-->
      <!-- Sidebar Links -->
      <ul class="list-unstyled components">
        <li class="submenu"
        >
          <router-link
            to=""
            :class="collapseDashboard ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="
              collapseDashboard ? 'true' : 'false'
            "
            @click.native="collapseItems('Dashboard')"
          >
            <div class="submenu-label" :title="$t(showTitle('label_sideMenu_dashboard'))">

              <img style="scale: 1.7" src="../../../public/static/icons/dashboard/dashboard.svg"/>
              <span>{{ $t("label_sideMenu_dashboard") }}</span>
            </div>
            <icon
              v-if="collapseDashboard"
              name="chevron-up"
              style="fill: #1e4380"
              class="submenu-icon"
              scale="1.1"
            />
            <icon
              v-else
              name="chevron-down"
              style="fill: #1e4380"
              class="submenu-icon"
              scale="1.1"
            />
          </router-link>
          <b-collapse
            id="collapse1"
            v-model="collapseDashboard"
          >
            <ul class="list-unstyled">
              <li
                :class="
                 ( route.name == 'Dashboard' ||
                  $route.name == 'Dashboard' )
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/dashboard">
                  <div class="submenu-label" :title="$t(showTitle('label_dashboard_title'))">
                    <img style="scale: 1.2" src="../../../public/static/icons/dashboard/ges.svg"/>
                    <span>{{
                        $t("label_dashboard_title")
                      }}</span>
                  </div>
                </router-link>
              </li>
              <li
                :class="
                  ( route.name == 'TrackerDashboard' ||
                  $route.name == 'TrackerDashboard' )
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/tracker-dashboard">
                  <div class="submenu-label" :title="$t(showTitle('label_tracker_dashboard_title'))">
                    <img style="scale: 1.2" src="../../../public/static/icons/dashboard/tracker.svg"/>
                    <span>{{
                        $t("label_tracker_dashboard_title")
                      }}</span>
                  </div>
                </router-link>
              </li>
              <li
                :class="
                  route.name == 'Home'
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/home">
                  <div class="submenu-label" :title="$t(showTitle('landing_eightPillars_title'))">
                    <img style="scale: 1.2"  src="../../../public/static/icons/dashboard/modules.svg"/>
                    <span>{{
                        $t("landing_eightPillars_title")
                      }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>

        <li v-if="getUserAccount.numberOfCompanies || getUserAccount.numberOfEvaluationsEvaluator" class="submenu">
          <router-link
            to=""
            :class="collapseSelfAssesment ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="collapseSelfAssesment ? 'true' : 'false'"
            @click.native="collapseItems('SelfAssessment');"
          >
            <div class="submenu-label" :title="$t(showTitle('label_selfAssessment_title_short'))">
              <img class="icon-svg" src="../../../public/static/icons/SelfAssessment/selfassessment.svg"/>
              <span>{{ $t("label_selfAssessment_title_short") }}</span>
            </div>
            <icon
                v-if="collapseSelfAssesment"
                name="chevron-up"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
              <icon
                v-else
                name="chevron-down"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
          </router-link>

          <b-collapse id="collapse1" v-model="collapseSelfAssesment">
            <ul class="list-unstyled">
              <li
                :class="route.name == 'SelfAssessmentGeneralInformation' ? 'active' : ''"
              >
                <router-link to="/self-assessment/general-information">
                  <div class="submenu-label" :title="$t(showTitle('label_selfAssessment_general_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/SelfAssessment/generalInformation.svg"/>
                    <span
                      >{{ $t("label_selfAssessment_general_title") }}
                      <b-badge
                        pill
                        :variant="
                          getSelfAssessmentScore('generalInformation') == 100
                            ? 'success'
                            : 'danger'
                        "
                        >{{ getSelfAssessmentScore("generalInformation") }}%</b-badge>
                      </span>
                  </div>
                </router-link>
              </li>
              <li :class="route.name == 'SelfAssessmentStaff' ? 'active' : ''">
                <router-link to="/self-assessment/staff">
                  <div class="submenu-label" :title="$t(showTitle('label_selfAssessment_staff_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/SelfAssessment/staff.svg"/>
                    <span
                      >{{ $t("label_selfAssessment_staff_title")}}
                      <b-badge
                        pill
                        :variant="
                          getSelfAssessmentScore('staff') == 100
                            ? 'success'
                            : 'danger'
                        "
                        >{{ getSelfAssessmentScore("staff") }}%</b-badge>
                      </span>
                  </div>
                </router-link>
              </li>
              <li
                :class="
                  route.name == 'SelfAssessmentLaborConditions' ? 'active' : ''
                "
              >
                <router-link to="/self-assessment/labor-conditions">
                  <div class="submenu-label" :title="$t(showTitle('label_selfAssessment_laborConditions_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/SelfAssessment/laborConditions.svg"/>
                    <span
                      >{{ $t("label_selfAssessment_laborConditions_title") }}
                      <b-badge
                        pill
                        :variant="
                          getSelfAssessmentScore('laborConditions') == 100
                            ? 'success'
                            : 'danger'
                        "
                        >{{ getSelfAssessmentScore("laborConditions") }}%
                        </b-badge>
                      </span>
                  </div>
                </router-link>
              </li>
              <li
                :class="
                  route.name == 'SelfAssessmentHumanResources' ? 'active' : ''
                "
              >
                <router-link to="/self-assessment/human-resources">
                  <div class="submenu-label" :title="$t(showTitle('label_selfAssessment_humanResources_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/SelfAssessment/humanResource.svg"/>
                    <span
                      >{{ $t("label_selfAssessment_humanResources_title") }}
                      <b-badge
                        pill
                        :variant="
                          getSelfAssessmentScore('humanResourceManagement') == 100
                            ? 'success'
                            : 'danger'
                        "
                        >{{ getSelfAssessmentScore("humanResourceManagement") }}%
                        </b-badge>
                      </span>
                  </div>
                </router-link>
              </li>
              <li
                :class="
                  route.name == 'SelfAssessmentEmploymentPolicies' ? 'active' : ''
                "
              >
                <router-link to="/self-assessment/employment-policies">
                  <div class="submenu-label" :title="$t(showTitle('label_selfAssessment_employmentPolicies_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/SelfAssessment/employmentPolicies.svg"/>
                    <span>
                      {{$t("label_selfAssessment_employmentPolicies_title")}}
                      <b-badge
                        pill
                        :variant="
                          getSelfAssessmentScore('employmentPolicies') == 100
                            ? 'success'
                            : 'danger'
                        "
                        >{{getSelfAssessmentScore("employmentPolicies")}}%
                        </b-badge>
                      </span>
                  </div>
                </router-link>
              </li>
              <li
                v-if="canUpdateSelfAssessment"
                :class="route.name == 'SelfAssessmentSubmitReview' ? 'active' : ''"
              >
                <router-link to="/self-assessment/submit-for-review">
                  <div class="submenu-label" :title="$t(showTitle('label_selfAssessment_submitReview_title_short'))">
                    <img class="subicon-svg" src="../../../public/static/icons/SelfAssessment/submitSelfAssessment.svg"/>
                    <span>{{$t("label_selfAssessment_submitReview_title_short")}}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li v-if="getUserAccount.numberOfCompanies || getUserAccount.numberOfEvaluationsEvaluator" class="submenu">
          <router-link
            to=""
            :class="collapseOpinionSurvey ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="collapseOpinionSurvey ? 'true' : 'false'"
            @click.native="collapseItems('OpinionSurvey');"
          >
            <div class="submenu-label" :title="$t(showTitle('label_opinionSurvey_title_short'))">
              <img class="icon-svg" src="../../../public/static/icons/Opinion_Survey/opinion-survey.svg"/>
              <span>{{ $t("label_opinionSurvey_title_short") }}</span>
            </div>
            <icon
                v-if="collapseOpinionSurvey"
                name="chevron-up"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
              <icon
                v-else
                name="chevron-down"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
          </router-link>
          <b-collapse id="collapse1" v-model="collapseOpinionSurvey">
            <ul class="list-unstyled">
              <li
                v-if="
                  getCurrentSnapshot.status !==
                  'label_configuration_snapshot_accepted'
                "
                :class="route.name == 'OpinionSurveySendInvitations' ? 'active' : ''"
              >
                <router-link to="/opinion-survey/send-invitations">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_opinionSurvey_sendInvitations'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Opinion_Survey/sendInvitations.svg"/>
                    <span>
                      {{ $t("label_sideMenu_opinionSurvey_sendInvitations") }}
                      <b-badge pill variant="success"
                        >{{ getInvitationsSent }}
                      </b-badge>
                    </span>
                  </div>
                </router-link>
              </li>
              <li
                :class="route.name == 'OpinionSurveyManagement' ? 'active' : ''"
              >
                <router-link to="/opinion-survey/survey-management">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_opinionSurvey_surveyManagement'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Opinion_Survey/surveyManagement.svg"/>
                    <span
                      >{{ $t("label_sideMenu_opinionSurvey_surveyManagement") }}
                      <b-badge
                        v-if="!isNaN(getInvitationsCompleted)"
                        pill
                        variant="danger"
                        >{{ getInvitationsCompleted }}%</b-badge
                      ></span
                    >
                  </div>
                </router-link>
              </li>
              <li
                :class="route.name == 'OpinionSurveyCalculator' ? 'active' : ''"
              >
                <router-link to="/opinion-survey/survey-calculator">
                  <div class="submenu-label" :title="$t(showTitle('label_opinionSurvey_calculator_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Opinion_Survey/sampleCalculator.svg"/>
                    <span>{{ $t("label_opinionSurvey_calculator_title") }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li
          v-if="
            getCurrentSnapshot.surveyViolenceStatus &&
            (getUserAccount.numberOfCompanies || getUserAccount.numberOfEvaluationsEvaluator)
          "
          class="submenu"
        >
          <router-link
            to=""
            :class="collapseViolenceSurvey ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="collapseViolenceSurvey ? 'true' : 'false'"
            @click.native="collapseItems('ViolenceSurvey');"
          >
            <div class="submenu-label" :class="!toggleSidebar ? 'd-flex justify-content-start align-items-center' : ''" :title="$t(showTitle('label_violenceSurvey_title'))">

              <img class="icon-svg" src="../../../public/static/icons/Violence Survey/violenceSurvey.svg"/>
              <span>{{ $t("label_violenceSurvey_title") }}</span>
            </div>
            <icon
                v-if="collapseViolenceSurvey"
                name="chevron-up"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
              <icon
                v-else
                name="chevron-down"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
          </router-link>
          <b-collapse id="collapse1" v-model="collapseViolenceSurvey">
            <ul class="list-unstyled">
              <li
                v-if="
                  getCurrentSnapshot.status !==
                  'label_configuration_snapshot_accepted'
                "
                :class="route.name == 'ViolenceSurveySendInvitations' ? 'active' : ''"
              >
                <router-link to="/violence-survey/send-invitations">
                  <div class="submenu-label" :class="!toggleSidebar ? 'd-flex justify-content-start align-items-center' : ''" :title="$t(showTitle('label_sideMenu_violenceSurvey_sendInvitations'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Violence Survey/ViolenceSendInvitations.svg"/>
                    <span>{{$t("label_sideMenu_violenceSurvey_sendInvitations")}}</span>
                  </div>
                </router-link>
              </li>
              <li
                :class="route.name == 'ViolenceSurveyManagement' ? 'active' : ''"
              >
                <router-link to="/violence-survey/survey-management">
                  <div class="submenu-label" :class="!toggleSidebar ? 'd-flex justify-content-start align-items-center' : ''" :title="$t(showTitle('label_sideMenu_violenceSurvey_surveyManagement'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Violence Survey/violenceSurveyManagement.svg"/>
                    <span>{{ $t("label_sideMenu_violenceSurvey_surveyManagement") }}</span>
                  </div>
                </router-link>
              </li>
              <li
                :class="route.name == 'ViolenceSurveyCalculator' ? 'active' : ''"
              >
                <router-link to="/violence-survey/survey-calculator">
                  <div class="submenu-label" :title="$t(showTitle('label_opinionSurvey_calculator_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Violence Survey/violenceSampleCalculator.svg"/>
                    <span>{{ $t("label_opinionSurvey_calculator_title") }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li v-if="getUserAccount.numberOfCompanies || getUserAccount.numberOfEvaluationsEvaluator" class="submenu">
          <router-link
            to=""
            :class="collapseResults ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="collapseResults ? 'true' : 'false'"
            @click.native="collapseItems('Results');"
          >
            <div class="submenu-label" :title="$t(showTitle('label_reports_title'))">

              <img class="icon-svg" src="../../../public/static/icons/Reports/reports.svg"/>
              <span>{{ $t("label_reports_title") }}</span>
            </div>
            <icon
                v-if="collapseResults"
                name="chevron-up"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
              <icon
                v-else
                name="chevron-down"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
          </router-link>
          <b-collapse id="collapse1" v-model="collapseResults">
            <ul class="list-unstyled">
              <li :class="route.name == 'ReportsGenderGap' ? 'active' : ''">
                <router-link to="/reports">
                  <div class="submenu-label" :title="$t(showTitle('label_reports_genderGap_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Reports/genderGapReport.svg"/>
                    <span>{{ $t("label_reports_genderGap_title") }}</span>
                  </div>
                </router-link>
              </li>
              <li
                :class="route.name == 'ReportsManagementReport' ? 'active' : ''"
              >
                <router-link to="/reports/management-report">
                  <div class="submenu-label" :class="!toggleSidebar ? 'd-flex justify-content-start align-items-center' : ''" :title="$t(showTitle('label_reports_managementReport_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Reports/managementReport.svg"/>
                    <span>{{ $t("label_reports_managementReport_title") }}</span>
                  </div>
                </router-link>
              </li>
              <li :class="route.name == 'ReportsOpinionSurvey' ? 'active' : ''">
                <router-link to="/reports/opinion-survey">
                  <div class="submenu-label" :class="!toggleSidebar ? 'd-flex justify-content-start align-items-center' : ''" :title="$t(showTitle('label_reports_opinionSurvey_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Reports/opinionSurveyReport.svg"/>
                    <span>{{ $t("label_reports_opinionSurvey_title") }}</span>
                  </div>
                </router-link>
              </li>
              <li
                v-if="getCurrentSnapshot.surveyViolenceStatus"
                :class="route.name == 'ReportsOrganizationalViolence' ? 'active' : ''"
              >
                <router-link to="/reports/organizational-violence">
                  <div class="submenu-label" :class="!toggleSidebar ? 'd-flex justify-content-start align-items-center' : ''" :title="$t(showTitle('label_reports_violenceSurvey_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Reports/violenceReport.svg"/>
                    <span>{{ $t("label_reports_violenceSurvey_title") }}</span>
                  </div>
                </router-link>
              </li>
              <li
                v-if="getCurrentSnapshot.surveyViolenceStatus"
                :class="route.name == 'ReportsViolenceSurvey' ? 'active' : ''"
              >
                <router-link to="/reports/violence-survey">
                  <div class="submenu-label" :class="!toggleSidebar ? 'd-flex justify-content-start align-items-center' : ''" :title="$t(showTitle('label_reports_violenceSurvey_dynamic_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Reports/violenceDynamic.svg"/>
                    <span>{{$t("label_reports_violenceSurvey_dynamic_title")}}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li v-if="getUserAccount.numberOfCompanies > 0" class="submenu">
          <router-link
            to=""
            :class="collapseAdvancedData ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="collapseAdvancedData ? 'true' : 'false'"
            @click.native="collapseItems('AdvancedData');"
          >
            <div class="submenu-label" :title="$t(showTitle('label_sideMenu_consolidatedData_title'))">

              <img class="icon-svg" src="../../../public/static/icons/Advanced_Data/advancedData.svg"/>
              <span>{{ $t("label_sideMenu_consolidatedData_title") }}</span>
            </div>
            <icon
                v-if="collapseAdvancedData"
                name="chevron-up"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
              <icon
                v-else
                name="chevron-down"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
          </router-link>
          <b-collapse id="collapse1" v-model="collapseAdvancedData">
            <ul class="list-unstyled">
              <li :class="route.name == 'Reportscomparative' ? 'active' : ''">
                <router-link to="/reports/comparative">
                  <div class="submenu-label" :title="$t(showTitle('label_advancedData_compare_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Advanced_Data/comparativeReport.svg"/>
                    <span>{{ $t("label_advancedData_compare_title") }}</span>
                  </div>
                </router-link>
              </li>
              <li :class="route.name == 'Reportsconsolidated' ? 'active' : ''">
                <router-link to="/reports/consolidated">
                  <div class="submenu-label" :title="$t(showTitle('label_advancedData_consolidate_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Advanced_Data/consolidatedReport.svg"/>
                    <span>{{ $t("label_advancedData_consolidate_title") }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <!--Evaluation Module-->
        <li v-if="isIndicaUser || isPNUDADMIN" class="submenu">
          <router-link
            to=""
            :class="collapseEvaluationModelAdmins ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="collapseEvaluationModelAdmins ? 'true' : 'false'"
            @click.native="collapseItems('EvaluationModelAdmins');"
          >
            <div class="submenu-label" :title="$t(showTitle('label_sideMenu_evaluation_administrator_title'))">

              <img class="icon-svg" src="../../../public/static/icons/Audit/admin_audit.svg"/>
              <span>{{ $t("label_sideMenu_evaluation_administrator_title") }}</span>
            </div>
            <icon
                v-if="collapseEvaluationModelAdmins"
                name="chevron-up"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
              <icon
                v-else
                name="chevron-down"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
          </router-link>
          <b-collapse id="collapse1" v-model="collapseEvaluationModelAdmins">
            <ul class="list-unstyled">
              <li
                :class="
                  route.name == 'EvaluationModels' ||
                  route.name == 'EvaluationModelsRequirements'
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/evaluation/evaluation-models">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_evaluation_administrator_models_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Audit/admin_audit_models.svg"/>
                    <span>{{$t("label_sideMenu_evaluation_administrator_models_title")}}</span>
                  </div>
                </router-link>
              </li>
              <li
                :class="
                  route.name == 'CreateEvaluation' ||
                  route.name == 'EvaluateEvaluation'
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/evaluation/create">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_evaluation_administrator_nodes_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Audit/admin_audit.svg"/>
                    <span>{{
                      $t("label_sideMenu_evaluation_administrator_nodes_title")
                    }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <!--Evaluation Module evaluators-->
        <li
          v-if="
            !isIndicaUser &&
            !isPNUDADMIN &&
            getUserAccount.numberOfEvaluationsEvaluator
          "
          class="submenu"
        >
          <router-link
            to=""
            :class="collapseEvaluationModelEvaluators ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="collapseEvaluationModelEvaluators ? 'true' : 'false'"
            @click.native="collapseItems('EvaluationModelEvaluators');"
          >
            <div class="submenu-label" :title="$t(showTitle('label_sideMenu_evaluation_evaluationMatrix_title'))">

              <img class="icon-svg" src="../../../public/static/icons/Audit/my_audits.svg"/>
              <span>{{$t("label_sideMenu_evaluation_evaluationMatrix_title")}}</span>
            </div>
            <icon
                v-if="collapseEvaluationModelEvaluators"
                name="chevron-up"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
              <icon
                v-else
                name="chevron-down"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
          </router-link>
          <b-collapse id="collapse1" v-model="collapseEvaluationModelEvaluators">
            <ul class="list-unstyled">
              <li
                :class="
                  route.name == 'CreateEvaluation' ||
                  route.name == 'EvaluateEvaluation'
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/evaluation/create">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_evaluation_evaluationMatrix_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Audit/my_audits.svg"/>
                    <span>{{
                      $t("label_sideMenu_evaluation_evaluationMatrix_title")
                    }}</span>
                  </div>
                </router-link>
              </li>
              <li
                :class="
                  route.name == 'ListReportsEvaluation' ||
                  route.name == 'EvaluationReport'
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/evaluation/reports">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_evaluation_evaluationReport_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Audit/audit_report.svg"/>
                    <span>{{
                      $t("label_sideMenu_evaluation_evaluationReport_title")
                    }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <!--Evaluation Module Organization-->
        <li
          v-if="
            isIndicaUser ||
            isPNUDADMIN ||
            (getUserAccount.numberOfEvaluationsResponsible ||
            getUserAccount.numberOfEvaluationsAccessTags)
          "
          class="submenu"
        >
          <router-link
            to=""
            :class="collapseEvaluationModelOrganization ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="
              collapseEvaluationModelOrganization ? 'true' : 'false'
            "
            @click.native="collapseItems('EvaluationModelOrganization');"
          >
            <div class="submenu-label" :title="$t(showTitle('label_evaluation_shortTitle'))">

              <img class="icon-svg" src="../../../public/static/icons/Audit/audit_organizations.svg"/>
              <span>{{ $t("label_evaluation_shortTitle") }}</span>
            </div>
            <icon
                v-if="collapseEvaluationModelOrganization"
                name="chevron-up"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
              <icon
                v-else
                name="chevron-down"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
          </router-link>
          <b-collapse
            id="collapse1"
            v-model="collapseEvaluationModelOrganization"
          >
            <ul class="list-unstyled">
              <li
                :class="
                  route.name == 'EvidencesRequested' ||
                  route.name == 'EvaluateOrganization'
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/evaluation/evidencesRequested">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_evaluation_evidencesRequested_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Audit/evidencesRequested_audit.svg"/>
                    <span>{{
                      $t("label_sideMenu_evaluation_evidencesRequested_title")
                    }}</span>
                  </div>
                </router-link>
              </li>
              <li
                :class="
                  route.name == 'ListReportsEvaluation' ||
                  route.name == 'EvaluationReport'
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/evaluation/reports">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_evaluation_evaluationReport_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Audit/audit_report.svg"/>
                    <span>{{
                      $t("label_sideMenu_evaluation_evaluationReport_title")
                    }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <!-- Tracker-->
        <li
          v-if="
            isIndicaUser ||
            isPNUDADMIN"
          class="submenu"
        >
          <router-link
            to=""
            :class="collapseTracker ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="
              collapseTracker ? 'true' : 'false'
            "
            @click.native="collapseItems('Tracker')"
          >
            <div class="submenu-label" :title="$t(showTitle('label_tracker'))">

              <img class="icon-svg" src="../../../public/static/icons/Audit/audit_organizations.svg"/>
              <span>{{ $t("label_sideMenu_tracker_import") }}</span>
            </div>
            <icon
              v-if="collapseTracker"
              name="chevron-up"
              style="fill: #1e4380"
              class="submenu-icon"
              scale="1.1"
            />
            <icon
              v-else
              name="chevron-down"
              style="fill: #1e4380"
              class="submenu-icon"
              scale="1.1"
            />
          </router-link>
          <b-collapse
            id="collapse1"
            v-model="collapseTracker"
          >
            <ul class="list-unstyled">
              <li
                :class="
                  route.name == 'TrackerImport'
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/tracker-import">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_import_tracker_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Audit/evidencesRequested_audit.svg"/>
                    <span>{{
                        $t("label_sideMenu_import_tracker_title")
                      }}</span>
                  </div>
                </router-link>
              </li>
              <li
                :class="
                  route.name == 'TrackerBackup'
                    ? 'active'
                    : ''
                "
              >
                <router-link to="/tracker-backup">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_tracker_backup_title'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Audit/evidencesRequested_audit.svg"/>
                    <span>{{
                        $t("label_sideMenu_tracker_backup_title")
                      }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <!-- Configuration -->
        <li v-if="isIndicaUser || isPNUDADMIN" class="submenu">
          <router-link
            to=""
            :class="collapseConfiguration ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="collapseConfiguration ? 'true' : 'false'"
            @click.native="collapseItems('Configuration');"
          >
            <div class="submenu-label" :class="!toggleSidebar ? 'd-flex justify-content-start align-items-center' : ''" :title="$t(showTitle('Users and Permissions Management'))">
              <img class="icon-svg" src="../../../public/static/icons/Users/users_management.svg"/>
              <span>Users and Permissions Management</span>

            </div>
            <icon
                v-if="collapseConfiguration"
                name="chevron-up"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
               />
                <icon
                  v-else
                  name="chevron-down"
                  style="fill: #1e4380"
                  class="submenu-icon"
                  scale="1.1"
                />
          </router-link>
          <b-collapse id="collapse1" v-model="collapseConfiguration">
            <ul class="list-unstyled">
              <li :class="route.name == 'ConfigurationWizard' ? 'active' : ''">
                <router-link to="/configuration/wizard">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_usersManagement_BusinessCreation'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Users/business_creation.svg"/>
                    <span>{{$t("label_sideMenu_usersManagement_BusinessCreation")}}</span>
                  </div>
                </router-link>
              </li>
              <li v-if="isIndicaUser || isPNUDADMIN" :class="route.name == 'accessControlTemplate' ? 'active' : ''">
                <router-link to="/configuration/accessControlTemplate">
                  <div class="submenu-label" :title="$t(showTitle('label_sideMenu_usersManagement_AccountRoleTemplate'))">
                    <img class="subicon-svg" src="../../../public/static/icons/Users/account_role_template.svg"/>
                    <span>{{$t("label_sideMenu_usersManagement_AccountRoleTemplate")}}</span>
                  </div>
                </router-link>
              </li>
              <template v-if="isIndicaUser || isPNUDADMIN">
              <div
                v-for="(table, tableIndex) in configurationTableList"
                :key="tableIndex"
              >
                <li
                  v-if="table.showInMenu"
                  :class="route.name === table.name ? 'active' : ''"
                >
                  <router-link :to="'/configuration/' + table.name + '/list'">
                    <div class="submenu-label" :title="showTitle(getConfigLabel(table))">
                      <img class="subicon-svg" :src="getConfigImage(table)" />
                      <span>{{ getConfigLabel(table) }}</span>
                    </div>
                  </router-link>
                </li>
              </div>
              </template>
            </ul>
          </b-collapse>
        </li>
        <!--Label Management-->
        <li v-if="isIndicaUser" class="submenu">
          <router-link
            to=""
            :class="collapseLocalization ? 'collapsed' : null"
            aria-controls="collapse1"
            :aria-expanded="collapseLocalization ? 'true' : 'false'"
            @click.native="collapseItems('Localization');"
          >
            <div class="submenu-label" :title="$t(showTitle('label_sideMenu_configuration_administration'))">
              <img class="icon-svg" src="../../../public/static/icons/Administration/system_administration.svg"/>
              <span>{{ $t("label_sideMenu_configuration_administration") }}</span>

            </div>
            <icon
                v-if="collapseLocalization"
                name="chevron-up"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
              <icon
                v-else
                name="chevron-down"
                style="fill: #1e4380"
                class="submenu-icon"
                scale="1.1"
              />
          </router-link>
          <b-collapse id="collapse1" v-model="collapseLocalization">
            <ul class="list-unstyled">
              <li :class="route.name == 'Languages' ? 'active' : ''">
                <router-link to="/Languages">
                  <div class="submenu-label" :title="showTitle('Languagess')">
                    <img class="subicon-svg" src="../../../public/static/icons/Administration/languages.svg"/>
                    <span>Languages</span>
                  </div>
                </router-link>
              </li>
              <li :class="route.name == 'LabelsBackup' ? 'active' : ''">
                <router-link to="/LabelsBackup">
                  <div class="submenu-label" :title="showTitle('Backup - Restore Languages')">
                    <img class="subicon-svg" src="../../../public/static/icons/Administration/backup_restore_languages.svg"/>
                    <span>Backup - Restore Languages</span>
                  </div>
                </router-link>
              </li>
              <li :class="route.name == 'LabelsManagement' ? 'active' : ''">
                <router-link to="/LabelsManagement">
                  <div class="submenu-label" :title="showTitle('Translations')">
                    <img class="subicon-svg" src="../../../public/static/icons/Administration/translations.svg"/>
                    <span>Translations</span>
                  </div>
                </router-link>
              </li>
              <li :class="route.name == 'LabelsExport' ? 'active' : ''">
                <router-link to="/LabelsExport">
                  <div class="submenu-label" :title="showTitle('Export Languages')">
                    <img class="subicon-svg" src="../../../public/static/icons/Administration/export_languages.svg"/>
                    <span>Export Languages</span>
                  </div>
                </router-link>
              </li>
              <li :class="route.name == 'LabelsImport' ? 'active' : ''">
                <router-link to="/LabelsImport">
                  <div class="submenu-label" :title="showTitle('Import Labels')">
                    <img class="subicon-svg" src="../../../public/static/icons/Administration/import_labels.svg"/>
                    <span>Import Labels</span>
                  </div>
                </router-link>
              </li>
              <li :class="route.name == 'LabelsRegenerateCache' ? 'active' : ''">
                <router-link to="/LabelsRegenerateCache">
                  <div class="submenu-label" :class="!toggleSidebar ? 'd-flex justify-content-start align-items-center' : ''" :title="showTitle('Regenerate Language Cache')">
                    <img class="subicon-svg" src="../../../public/static/icons/Administration/regenerate_language_cache.svg"/>
                    <span>Regenerate Language Cache</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <!--
            <b-collapse v-model="collapseSettings" id="collapse1">
                <ul class="list-unstyled">
                  <li :class="route.name == 'CompaniesAdd' ? 'active': ''">
                      <router-link to="/configuration/access-control">
                          <icon name="industry" scale="1.1"></icon> <span>{{ $t("label_sideMenu_configuration_companies") }}</span>
                      </router-link>
                      b-tooltip class="tooltip" target="tthome" placement="right">
                        Inicio
                      </b-tooltip>-- >
                  </li>
                  <li :class="route.name == 'ConfigurationAccessControl' ? 'active': ''">
                      <router-link to="/configuration/access-control">
                          <i class="icon icon-access-control"></i> <span>{{ $t("label_sideMenu_configuration_accessControl") }}</span>
                      </router-link>
                      <b-tooltip class="tooltip" target="tthome" placement="right">
                        Inicio
                      </b-tooltip>
                  </li>
                  <li :class="route.name == 'Users' ? 'active': ''">
                      <router-link to="/configuration/access-control">
                          <i class="icon icon-localization"></i> <span>{{ $t("label_sideMenu_configuration_localization") }}</span>
                      </router-link>
                      < !--<b-tooltip class="tooltip" target="tthome" placement="right">
                        Inicio
                      </b-tooltip>-- >
                  </li>
                  <li :class="route.name == 'Users' ? 'active': ''">
                      <router-link to="/configuration/access-control">
                          <i class="icon icon-modules"></i> <span>{{ $t("label_sideMenu_configuration_modules") }}</span>
                      </router-link>
                      < !--<b-tooltip class="tooltip" target="tthome" placement="right">
                        Inicio
                      </b-tooltip>-- >
                  </li>
                  <li :class="route.name == 'Users' ? 'active': ''">
                      <router-link to="/configuration/access-control">
                          <icon name="cog" scale="1.1"></icon> <span>{{ $t("label_sideMenu_configuration_settings") }}</span>
                      </router-link>
                      < !--<b-tooltip class="tooltip" target="tthome" placement="right">
                        Inicio
                      </b-tooltip>-- >
                  </li>
                </ul>
            </b-collapse>
        </li>-->
      </ul>
      <ul class="list-unstyled CTAs">
        <li>
          <b-button variant="third" style="min-height: 45px;" v-if="toggleSidebar" @click="toggleSidebar = !toggleSidebar">
            <i class="icon icon-expand" />
          </b-button>
          <b-button variant="third" style="min-height: 45px;"  v-else @click="toggleSidebar = !toggleSidebar">
            <i class="icon icon-collapse" />
          </b-button>
        </li>
      </ul>
      <div v-show="!toggleSidebar" class="pnud-logo">
        <img
          class="mx-auto d-block"
          :src="'/static/images/unpd/unpd_logo_color_' + lang + '.svg'"
          height="200"
        />
      </div>
      <div class="opener">
        <b-button v-if="toggleSidebar" @click="toggleSidebar = !toggleSidebar">
          <i class="icon icon-collapse" />
        </b-button>
        <b-button v-else @click="toggleSidebar = !toggleSidebar">
          <i class="icon icon-expand" />
        </b-button>
      </div>
      <template-role-selector />
      <!--<migration v-if="isIndicaUser"/> -->
    </div>
  </nav>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import { mapGetters } from "vuex";
import { ConfigurationTableList } from "../../utils/forms/tablesConfiguration";
//import Migration from "@/components/Migration";

const { mapFields } = createHelpers({
  getterType: "getUserAccountField",
  mutationType: "updateUserAccountField",
});

export default {
  name: "Sidebar",
  props: ["isAuthenticated", "active"],
  //components: {Migration},
  data: function () {
    return {
      user: {
        rol: "admin",
      },
      evaluationsList: [],
      configurationTableList: ConfigurationTableList,
      toggleSidebar: false,
      collapseDashboard: false,
      collapseSelfAssesment: false,
      collapseResults: false,
      collapseSettings: false,
      collapseResources: false,
      collapseOpinionSurvey: false,
      collapseViolenceSurvey: false,
      collapseAdvancedData: false,
      collapseEvaluationModelAdmins: false,
      collapseEvaluationModelEvaluators: false,
      collapseEvaluationModelOrganization: false,
      collapseTracker: false,
      collapseConfiguration: false,
      collapseLocalization: false,
      route: "",
    };
  },
  watch: {
    $route(to) {
      this.route = to;
      if (window.innerWidth < 1170) {
        this.toggleSidebar = true;
        if (window.innerWidth <= 540) {
          this.toggleSidebar = false;
        }
      }
    },
  },
  computed: {
    ...mapFields(["username"]),
    ...mapGetters([
      "getInvitationsSent",
      "getInvitationsCompleted",
      "getSelfAssessmentAdvance",
      "canUpdateSelfAssessment",
      "getCurrentSnapshot",
      "getSelfAssessment",
      "getReloadSelfAssessment",
      "getUserAccount",
      "getCurrentAccountRoleId",
      "isPNUDADMIN",
      "isIndicaUser",
      'getSelfAssessmentScore'
    ]),
    lang() {
      return this.$i18n.locale;
    },

  },
  async mounted() {
    if (window.innerWidth < 1170) {
      this.toggleSidebar = true;
      if (window.innerWidth <= 540) {
        this.toggleSidebar = false;
      }
    }
    setTimeout(() => {
      this.toggleSidebar = true;
    }, 3000);
  },
  methods: {
    collapseItems(itemVar){
      this.collapseDashboard = (itemVar == 'Dashboard' ? !this.collapseDashboard : false);
      this.collapseSelfAssesment = (itemVar == 'SelfAssessment' ? !this.collapseSelfAssesment : false);
      this.collapseResults = (itemVar == 'Results'? !this.collapseResults : false)
      this.collapseSettings = (itemVar == 'Settings' ? !this.collapseSettings : false)
      this.collapseResources = (itemVar == 'Resources' ? !this.collapseResources : false)
      this.collapseOpinionSurvey = (itemVar == 'OpinionSurvey' ? !this.collapseOpinionSurvey : false)
      this.collapseViolenceSurvey = (itemVar == 'ViolenceSurvey' ? !this.collapseViolenceSurvey : false)
      this.collapseAdvancedData = (itemVar == 'AdvancedData' ? !this.collapseAdvancedData : false)
      this.collapseEvaluationModelAdmins = (itemVar == 'EvaluationModelAdmins' ? !this.collapseEvaluationModelAdmins : false)
      this.collapseEvaluationModelEvaluators = (itemVar == 'EvaluationModelEvaluators' ? !this.collapseEvaluationModelEvaluators : false)
      this.collapseEvaluationModelOrganization = (itemVar == 'EvaluationModelOrganization' ? !this.collapseEvaluationModelOrganization : false)
      this.collapseConfiguration = (itemVar == 'Configuration' ? !this.collapseConfiguration : false)
      this.collapseLocalization = (itemVar == 'Localization' ? !this.collapseLocalization : false)
      this.collapseTracker = (itemVar == 'Tracker' ? !this.collapseLocalization : false)
    },
    showTitle(title){
      if(this.toggleSidebar)
        return title
      else return ''
    },
    getConfigLabel(table) {
      let tableDescription = this.getTableDescription(table.name);
      return tableDescription ? this.$t(tableDescription.title) : "";
    },
    getConfigImage(table) {
      let tableDescription = this.getTableDescription(table.name);
      let image = null;
      if (tableDescription) {
        try {
          image = require(`../../../public/static/icons/Users/${tableDescription.icon}.svg`);
        } catch (e) {
          console.log(e);
        }
      } else {
        console.log("no icon for", table.name);
      }
      return image;
    },
    getTableDescription(table) {
      let tableDescription = [
        {
          routeName: "UserAccounts",
          title: "label_sideMenu_usersManagement_Users",
          icon: "users",
        },
        {
          routeName: "AccountRoles",
          title: "label_sideMenu_usersManagement_Roles",
          icon: "roles",
        },
        {
          routeName: "Country",
          title: "label_sideMenu_usersManagement_Country",
          icon: "country",
        },
        {
          routeName: "Region",
          title: "label_sideMenu_usersManagement_Region",
          icon: "region",
        },
        {
          routeName: "Business",
          title: "label_sideMenu_usersManagement_Business",
          icon: "company",
        },
        {
          routeName: "Snapshot",
          title: "label_sideMenu_usersManagement_Snapshot",
          icon: "snapshots",
        },
        {
          routeName: "Tag",
          title: "label_sideMenu_usersManagement_Tag",
          icon: "tag",
        },
        {
          routeName: "RoleType",
          title: "label_sideMenu_usersManagement_RoleType",
          icon: "role_type",
        },
      ];
      return tableDescription.find((td) => td.routeName === table);
    },
    checkAssesment: function () {
      if (
        typeof this.getSelfAssessment.id === "undefined" ||
        this.getReloadSelfAssessment === true
      ) {
        this.$store
          .dispatch("SELF_ASSESSMENT_GET")
          .then(() => {
            this.$store.commit("setReloadSelfAssessment", false);
            this.$router.go({
              path: this.$router.path,
              query: {
                t: +new Date(),
              },
            });
          })
          .catch((err) => {
            console.log(err);
            this.$router.push("/home"); // TODO Handle the error in a better way
          });
      } else {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* components/template/_template-sidebar.vue */
@import "../../assets/css/variables.scss";

#sidebar{
    &.active{
      .submenu-icon {
        &.fa-icon {
          top: 43px !important;
           }
        }
      }
    }

#sidebar {

  max-width: 325px;
  min-width: 325px;
  background: $third-color;
  color: $primary-color;
  transition: all 0.3s;
  font-family: $font-subtitle;
  .scrolleable{
    position: -webkit-sticky;
    position: sticky;
    top: 50px;
    height: calc(100vh - 50px);
    overflow-y: auto;
  }
  a {
    color: $primary-color;
  }
  a,
  a:hover,
  a:focus {
    text-decoration: none;
    transition: all 0.3s;
  }
  .sidebar-header {
    padding: 20px;
    border-bottom: 1px solid $accent-color;
    strong {
      display: none;
      font-size: 1.8em;
    }
    h3 {
      margin: 0;
    }
  }
  ul li {
    text-transform: uppercase;
    font-family: $font-title;
    font-size: 0.9rem;
    &:nth-child(odd) {
      background: #f3f3f5;
    }
    &:nth-child(even) {
      background: #d6e0ef;
    }
    &.active > a {
      color: #fff !important;
      background: $primary-color;
      img{
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(108deg) brightness(104%) contrast(104%);

      }
    }
    span{
      margin-left: 15px;
      text-align: left;
    }
    a {
      padding: 10px 10px 10px 25px;
      font-size: 1.1em;
      display: block;
      text-align: left;
      }
    .submenu-label {
      transition: scale 0.75s;
      &:hover{
        scale: 1.075;
      }

    }
    img {
      width: 19px;
      height: 19px;
      &:hover {
        color: #ffffff;
      }
      &:hover > .icon {
        color: #fff;
      }
    }
  }
  .submenu {
    position: relative;
    .submenu-icon {
      position: absolute;
      right: 13px;
      top: 12px;
      }
  }
  ul ul {
    li {
      text-transform: initial;
      font-family: $font-subtitle;
      font-size: 0.9rem;
      .icon {
        background-color: $primary-color;
      }
    }
    a {
      font-size: 1.1em !important;
      padding-left: 25px !important;
      background: #f8fcff;
      color: $primary-color;
    }
  }
  ul.CTAs {
    padding: 0px;
    text-align: center;
    button {
      border: none;
      box-shodow: none;
      color: #fff;
      width: 100%;
      border-radius: 0;
      padding: 7.5px;
    }
    .icon {
      background-color: #fff;
    }
  }
  ul.components {
    padding: 0;
    margin-bottom: 0px;
  }
  &.active {
    min-width: 80px;
    max-width: 80px;
    text-align: center;

    .sidebar-header h3,
    span {
      display: none;
    }
    .sidebar-header strong {
      display: block;
    }
    .submenu-icon {
      top: 40px !important;
      bottom: 5px;
      right: 50% !important;
      width: 10px;
      -webkit-transform: translateX(50%);
      -ms-transform: translateX(50%);
      transform: translateX(50%);
    }
  }
  .fa-icon {
    position: relative;
  }
  .icon {
    height: 1.2rem;
    width: 1.2rem;
    position: relative;
    margin: 0px;
  }
  .badge-success {
    background-color: $accent-color;
  }
  .badge-danger {
    background-color: $secondary-color;
  }
  .opener {
    display: none;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  $icons: ('home', 'selfassessment', 'human-resources', 'equality-seal', 'collapse', 'expand', 'language', 'opinion-survey', 'send-invitations', 'invitations-management', 'access-control', 'localization', 'modules', 'submit-review', 'export-pdf');
  #sidebar {
    ul li {
      &:hover {
        color: #ffffff;
        background: #0e756d;
      }
    }
    [aria-expanded="true"] .icon {
      @each $icon in $icons {
        &.icon-#{$icon}:after {
          content: url(/static/icons/#{$icon}_menu_icon_active.svg);
        }
      }
    }
  }
};

#sidebar.active ul li a {
  padding: 20px 10px;
  text-align: center;
  font-size: 0.85em;

  i {
    margin-right: 0;
    font-size: 1.8em;
    margin-bottom: 5px;
  }
}

#sidebar.active ul ul a {
  padding: 10px !important;
}

#sidebar.active a[aria-expanded="false"]::before,
#sidebar.active a[aria-expanded="true"]::before {
  top: auto;
  bottom: 5px;
  right: 50%;
  -webkit-transform: translateX(50%);
  -ms-transform: translateX(50%);
  transform: translateX(50%);
  background-color: white;
}

/* ---------------------------------------------------
    MEDIAQUERIES
----------------------------------------------------- */
@media (max-width: 540px) {
  #sidebar {
    text-align: center;
    margin-left: -275px !important;
  }
  a[aria-expanded="false"]::before,
  a[aria-expanded="true"]::before {
    top: auto;
    bottom: 5px;
    right: 50%;
    -webkit-transform: translateX(50%);
    -ms-transform: translateX(50%);
    transform: translateX(50%);
  }
  #sidebar.active {
    margin-left: 0 !important;
  }

  #sidebar .sidebar-header h3,
  #sidebar .CTAs {
    display: none;
  }

  #sidebar .sidebar-header strong {
    display: block;
  }

  #sidebar ul li a {
    padding: 20px 10px;
  }

  #sidebar ul li a span {
    font-size: 0.85em;
  }
  #sidebar ul li a i {
    margin-right: 0;
  }

  #sidebar ul ul a {
    padding: 10px !important;
  }

  #sidebar ul li a i {
    font-size: 1.3em;
  }
  #sidebar {
    margin-left: 0;
  }
  #sidebarCollapse span {
    display: none;
  }

  #sidebar {
    .pnud-logo {
      display: none;
    }
    .opener {
      display: block;
      position: fixed;
      left: -10px;
      bottom: 3px;
      z-index: 100;
      button {
        border-radius: 0 5px 5px 0;
        padding: 3px 7px 3px 12px;
        background-color: #545b62de;
        .icon {
          background-color: white;
        }
      }
    }
  }
}
.router-link-active:hover .pngHover {
  filter: brightness(100) grayscale(1);
}

.icon-svg{
  scale: 1.7;
  filter: invert(18%) sepia(84%) saturate(1494%) hue-rotate(201deg) brightness(91%) contrast(89%);
}
.subicon-svg{
  scale: 1.2;
  filter: invert(18%) sepia(84%) saturate(1494%) hue-rotate(201deg) brightness(91%) contrast(89%);
}
</style>
